import { render, staticRenderFns } from "./kalog.vue?vue&type=template&id=2dad7665&scoped=true&"
import script from "./kalog.vue?vue&type=script&lang=js&"
export * from "./kalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad7665",
  null
  
)

export default component.exports